var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntegrations = function SvgIntegrations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    fillRule: "evenodd",
    d: "M24.524 33.13a3.44 3.44 0 0 1 0 6.882h-.75v5.036c0 .69-.56 1.25-1.25 1.25h-5l-.144.563a3.442 3.442 0 0 1-6.664 0l-.145-.563h-5c-.69 0-1.25-.56-1.25-1.25V28.095c0-.69.56-1.25 1.25-1.25h3.593a4.942 4.942 0 0 0 9.768 0h3.592c.69 0 1.25.56 1.25 1.25v5.036z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M31.56 47.048a3.44 3.44 0 1 1 6.88 0v.75h5.036c.69 0 1.25.56 1.25 1.25v4.999l.563.145a3.442 3.442 0 0 1 0 6.664l-.563.145V66c0 .69-.56 1.25-1.25 1.25H26.524c-.69 0-1.25-.56-1.25-1.25v-3.592a4.942 4.942 0 0 0 0-9.768v-3.592c0-.69.56-1.25 1.25-1.25h5.035z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    fillRule: "evenodd",
    d: "M38.332 26.282a3.442 3.442 0 0 0-6.664 0l-.145.563h-5c-.69 0-1.25.56-1.25 1.25v3.593a4.942 4.942 0 0 1 0 9.767v3.593c0 .69.56 1.25 1.25 1.25h3.593a4.942 4.942 0 0 1 9.768 0h3.592c.69 0 1.25-.56 1.25-1.25v-5.036h.75a3.44 3.44 0 1 0 0-6.881h-.75v-5.036c0-.69-.56-1.25-1.25-1.25h-4.999z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    fillRule: "evenodd",
    d: "M52.512 26.095a3.44 3.44 0 1 1 6.88 0v.75h5.036c.69 0 1.25.56 1.25 1.25v16.953c0 .69-.56 1.25-1.25 1.25H59.43l-.145.563a3.442 3.442 0 0 1-6.664 0l-.145-.563h-4.999c-.69 0-1.25-.56-1.25-1.25v-3.593a4.942 4.942 0 0 0 0-9.767v-3.593c0-.69.56-1.25 1.25-1.25h5.036z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M52.62 5.33a3.442 3.442 0 0 1 6.665 0l.144.563h5c.69 0 1.25.56 1.25 1.25v16.952c0 .69-.56 1.25-1.25 1.25h-3.593a4.942 4.942 0 0 0-9.768 0h-3.592c-.69 0-1.25-.56-1.25-1.25V19.06h-.75a3.44 3.44 0 1 1 0-6.881h.75V7.143c0-.69.56-1.25 1.25-1.25h5z",
    clipRule: "evenodd"
  })));
};
export default SvgIntegrations;